import { greenscaleId } from "../constants/themeIds";

const greenscale = {
  author: "ImACoderImACoderImACoder/ayebizz",
  themeId: greenscaleId,
  buttonColorMain: "#242526",
  currentTemperatureColor: "#0fca06",
  borderColor: "#B0B3B8",
  buttonActive: {
    color: "white",
    backgroundColor: "#0fca06",
    borderColor: "white",
  },
  backgroundColor: "black",
  primaryFontColor: "#0fca06",
  iconColor: "#0fca06",
  iconTextColor: "#0fca06",
  temperatureRange: {
    background: "linear-gradient(315deg,  #0fca06 0%, #B0B3B8 74%)",
    rangeBoxColor: "#0fca06",
    rangeBoxBorderColor: "white",
  },
  plusMinusButtons: {
    backgroundColor: "#242526",
    color: "#0fca06",
    borderColor: "#B0B3B8",
  },
  workflowEditor: {
    accordianExpandedColor: "#0fca06",
  },
  ToggleButtons: {
    sliderBackgroundColorOn: "#0fca06",
    sliderBackgroundColorOff: "#B0B3B8",
    sliderBorderColorOn: "#f8f9fa",
    onBackgroundColor: "#0fca06",
    onBorderColor: "white",
    onColor: "white",
    offBackgroundColor: "#242526",
    offBorderColor: "#B0B3B8",
    offColor: "#0fca06",
  },
};

export default greenscale;
